/**
 * compile and export all form components from one file
 */

import CdnPathInput from './CdnPathInput.js.jsx';
import CheckboxInput from './CheckboxInput.js.jsx';
import DateRangePickerInput from './dates/DateRangePickerInput.js.jsx';
import EmailInput from './EmailInput.js.jsx';
import FileInput from './FileInput.js.jsx';
import ListComparator from './ListComparator.js.jsx';
import MonthYearInput from './dates/MonthYearInput.js.jsx';
import NewPasswordInput from './NewPasswordInput.js.jsx';
import NumberInput from './NumberInput.js.jsx';
import ObjectListComparator from './ObjectListComparator.js.jsx';
import PasswordInput from './PasswordInput.js.jsx';
import RadioInput from './RadioInput.js.jsx';
import RichEditor from './RichEditor.js.jsx';
import SearchInput from './SearchInput.js.jsx';
import SelectFromArray from './SelectFromArray.js.jsx';
import SelectFromObject from './SelectFromObject.js.jsx';
import SimpleArrayEditor from './SimpleArrayEditor.js.jsx';
import SingleDatePickerInput from './dates/SingleDatePickerInput.js.jsx';
import TextAreaInput from './TextAreaInput.js.jsx';
import TextInput from './TextInput.js.jsx';
import UrlInput from './UrlInput.js.jsx';

export { CdnPathInput };
export { CheckboxInput };
export { DateRangePickerInput };
export { EmailInput };
export { FileInput };
export { ListComparator };
export { MonthYearInput };
export { NewPasswordInput };
export { NumberInput };
export { ObjectListComparator };
export { PasswordInput };
export { RadioInput };
export { RichEditor };
export { SearchInput };
export { SelectFromArray };
export { SelectFromObject };
export { SimpleArrayEditor };
export { SingleDatePickerInput };
export { TextAreaInput };
export { TextInput };
export { UrlInput };

export default {
  CdnPathInput
  , CheckboxInput
  , DateRangePickerInput
  , EmailInput
  , FileInput
  , ListComparator
  , MonthYearInput
  , NewPasswordInput
  , NumberInput
  , ObjectListComparator
  , PasswordInput
  , RadioInput
  , RichEditor
  , SearchInput
  , SelectFromArray
  , SelectFromObject
  , SimpleArrayEditor
  , SingleDatePickerInput
  , TextAreaInput
  , TextInput
  , UrlInput
}



// WEBPACK FOOTER //
// global/components/forms/index.js